import React from 'react'
import { Header } from '../../components/common/Header'
import { Patients } from '../../components/Patients'

import './index.less'
import { ModalRecoveryKey } from '../../components/user/ModalRecoveryKey'

export default function DashboardPage() {
  return (
    <div className="Dashboard">
      <Header />
      <Patients />
      <ModalRecoveryKey />
    </div>
  )
}
